module.exports = __webpack_public_path__ + "img/apple_pay_mark_rgb.786bcb24.svg";